export default function () {
  return {
    cachearticles: [],
    cachearticlesCurrentPage: 1,
    cachearticlesLastPage: 1,
    cachearticlesPerPage: 0,
    cachearticlesTotal: 0,
    cachearticlesLoading: false,
    indexPage: null
  }
}
